import { Text, View } from "@react-pdf/renderer";
import styles from '../styles/styles';
import Element from "./element";

interface FilesProps {
  labels: {
    header: string;
    files: string;
  };
  data: {
    files: string | null | undefined;
  };
}

const Files = ({ labels, data }: FilesProps) => (
  <>
    <View style={styles.row}>
      <Text style={styles.subHeader}>{labels.header}</Text>
    </View>

    {data.files !== undefined && <>
      <View style={styles.miniSpacer} />

      <View style={styles.row}>
        <Element label={labels.files} data={data.files} />
      </View>
    </>}
  </>
);

export default Files;